






import Vue from 'vue';

import OrganizationUserSettings from '@/views/authenticated/OrganizationUserSettings.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationUserSettings,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    memberId: Number
  }
});
